import { Duty, DutyClient, VMDutyCreate } from "../backend/backendapi";
import { handleError, initClient } from "../../api";
import VueI18n from "vue-i18n";
import { Toasted } from "vue-toasted";

const dutyApi = initClient(DutyClient);

export async function getVMDutyCreate(dutyId: number): Promise<VMDutyCreate> {
    const vmedit = await dutyApi.getDuty(dutyId);
    const todolist = vmedit.duty.checklists?.length ? vmedit.duty.checklists[0] : null;
    const dutyCreate = new VMDutyCreate({
        duty: vmedit.duty,
        users: [...(vmedit.usersSelected ?? [])],
        cells: [...(vmedit.cellsSelected ?? [])],
        triggers: [...(vmedit.triggers ?? [])],
        triggerSelected: 0,
        strJsonTodo: todolist?.json ?? '[]',
        idTodoList: todolist?.id ?? 0,
    });
    return dutyCreate;
}

export async function massEditDuty(duties: Duty[], editor: (dutyCreate: VMDutyCreate) => void, $toasted: Toasted, $i18n: VueI18n): Promise<{ success: number, failed: number }> {
    const promises = duties.map(async duty => {
        const dutyCreate = await getVMDutyCreate(duty.dutyId!);
        editor(dutyCreate);
        await dutyApi.updateDuty(dutyCreate);
    });
    let success = 0;
    let failed = 0;
    for (let promise of promises) {
        try {
            await promise;
            success++;
        } catch (e) {
            failed++;
            handleError($toasted, $i18n, e);
        }
    }
    $toasted.info($i18n.t('txtSaved').toString() + ' (' + success + '/' + promises.length + ')');
    return { success: success, failed: failed };
}